module.exports = new __parcel__URL__("model-photo-card-stats-icon.2cb48820.png").toString();